import React from 'react';
import './styles.css';
import { Icon } from '../Icon';

export const Logo = ({ size = 56, className = '', ...props }) => {
  return (
    <div className={`logo ${className}`} style={{ width: size, height: size }} {...props}>
      <Icon 
        name="bolt" 
        size={size} 
        color="var(--color-primary)" 
        className="logo-icon"
      />
    </div>
  );
}; 